import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

import { useSoftphone } from "./SoftphoneContext";

/** Clickable phone number: starts an outgoing call through the softphone. */
export const PhoneLink = ({ number }: { number?: string | null }) => {
  const { call, enabled, status } = useSoftphone();
  if (!number) return null;

  const canCall = enabled && status === "ready";

  return (
    <span className="inline-flex items-center gap-1">
      <span>{number}</span>
      <Button
        variant="ghost"
        size="icon"
        className="h-6 w-6 text-green-600 disabled:opacity-40"
        disabled={!canCall}
        onClick={(event) => {
          event.stopPropagation();
          call(number);
        }}
        aria-label={`Позвонить ${number}`}
        title={canCall ? "Позвонить" : "Телефония недоступна"}
      >
        <Phone className="w-3.5 h-3.5" />
      </Button>
    </span>
  );
};
